import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class UserSignUpRoute extends Route {
  @service("ember-store") store
  @service session

  afterModel(model, transition) {
    if (this.session.isAuthenticated && this.session.userId) {
      let userPromise = this.store.find("user", this.session.userId)
      userPromise.then((user) => {
        // if you have planbooks, don't let you create your first one all over again
        if (user.relationships.planbooks.data.length > 0) {
          this.replaceWith("user.show", user.id)
        }
      })
    }
  }
}
